import List from "@/components/list";
const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editData = listeners["editData"] || function () { };
  const deleteData = listeners["deleteData"] || function () { };
  const setOrganize = listeners["setOrganize"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => { editData(vo.row) }, "organizationTag:update"],
      ["icon-delete", "删除", () => { deleteData(vo.row) }, "organizationTag:delete"],
      ["iconfont icshezhizuzhi_sel iconfont-adapt", "设置组织", () => { setOrganize(vo.row) }, "organizationTag:setDept"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "标签名称",
      prop: "name",
      minWidth: "300",
    },
    {
      label: "操作",
      width: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
